export const reorderArray = <T>(items: T[], source: number, target: number): T[] => {
  const result = [...items]
  const [moved] = result.splice(source, 1)

  if (moved === undefined) return items

  result.splice(target, 0, moved)

  return result
}
